/* eslint-disable @typescript-eslint/no-explicit-any */
import { SubNavContainer } from '@/components/sub-nav-container';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/accessibility/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Accessibility - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

const ListingItem: React.FC<{
  index: number;
  title: string;
  description: string;
}> = ({ index, title, description }) => {
  return (
    <div className="flex flex-col mb-6">
      <h2 className="text-xl font-bold text-foreground">
        {index}. {title}
      </h2>
      <p className="text-base font-normal text-foreground leading-6 py-4">{description}</p>
    </div>
  );
};

function RouteComponent() {
  const { t } = useTranslation();
  return (
    <>
      <SubNavContainer showOneStepBreadcrumbs>
        <div className="max-w-container-960">
          <h1 className="text-3xl font-bold text-foreground">{t('accessibility.title')}</h1>
          <p className="text-xl font-normal text-foreground pt-5 pb-8">{t('accessibility.subtitle')}</p>
        </div>
      </SubNavContainer>

      <main className="max-w-container-960 mx-auto pt-8 pb-20 px-4 lg:px-0">
        <div className="space-y-6">
          {Array.from({ length: 7 }, (_, index) => (
            <ListingItem
              key={index}
              index={index + 1}
              title={t(`accessibility.listing.${index}.title` as any)}
              description={t(`accessibility.listing.${index}.description` as any)}
            />
          ))}
        </div>
      </main>
    </>
  );
}
